module.exports = __webpack_public_path__ + "img/content8.17b4aba4.png";